import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine4Footnote2Props extends ITextBoxProps {}

export const TextBoxMaxLine4Footnote2 = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.Footnote2,
  maxLines = 4,
  ...rest
}: ITextBoxMaxLine4Footnote2Props): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    maxLines={maxLines}
    {...rest}
  />
)
